import React, { Component, Fragment } from 'react'
import { StyleSheet, css } from 'aphrodite'
import Dialog from '@material-ui/core/Dialog'

import { AppStyles, AppTheme } from '../styles/AppTheme'
import { CustomMessageDialogStyles } from '../styles/CustomStyles'
import { AppConfig } from '../AppConfig'
// import { AppHelper } from '../helpers/AppHelper'
import { CircularProgress, styled } from '@material-ui/core'
import Tooltip from '@material-ui/core/Tooltip';
// import { UiHelper } from '../common/helpers/UiHelper'
import { Helper } from '../common/helpers/Helper'
import { UiHelper } from '../common/helpers/UiHelper'
import { AppHelper } from '../helpers/AppHelper'
import { Fade, Slide } from '@material-ui/core';
import { AppUiHelper } from '../helpers/AppUiHelper'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});
export class VenueAdsPlayer extends Component {

  constructor(props) {
    super(props)
    this.state = {
      timerElement: '',
      currentPlayIndex: 0
    }
    this.size = {
      portrait:{
        width:1080,
        height:1920,
      },
      landscape:{
        width:1920,
        height:1080,
      },
    }
    this.loop = 0
  }

  componentDidUpdate(prevProps) {
    if (prevProps.inProcess !== this.props.inProcess && this.props.inProcess === false && !this.props.showError) {
      this._startPlayingAds()
    }
  }
  componentWillUnmount() {
    this._resetPlayer()
  }

  onCloseModal() {
    this.props.onClosed()
  }

  _resetPlayer() {
    this.loop = 0
    if(this.mediaContainer) this.mediaContainer.innerHTML = ''
    if(this.state.timerElement) this.setState({timerElement:''})
    if(this.mediaContent) this.mediaContent = [] // Reset the media content array
    this.setState({currentPlayIndex: 0})
    if(this.timerPlayerTimeout) clearTimeout(this.timerPlayerTimeout)
    if(this.timerInterval) clearInterval(this.timerInterval)
  }

  _startPlayingAds() {
    if (this.props.ads && this.props.ads.length > 0) {
      this.mediaContainer = document.getElementById('mediaContainer')
      this.mediaContents = [...this.props.ads]
      this.setState({currentPlayIndex: 0})
      this.orientation = this.props.orientation ? this.props.orientation.toLowerCase() : 'portrait'
      this._playNextMedia()
    }
  }

  _playMedia(content) {
    this.mediaContainer.innerHTML = ''

    if (content.mediaType === 'VIDEO') {
      const video = document.createElement('video')
      video.src = content.content
      video.class = css(Styles.contentVideo)
      video.controls = false
      video.autoplay = true
      video.muted = true
      video.classList.add(css(Styles.contentVideo))

      const elementHolder = document.createElement('div');
      elementHolder.classList.add(css(Styles[this.orientation + 'MediaHolder']));
      elementHolder.appendChild(video)

      this.mediaContainer.appendChild(elementHolder)
      this._displayTimer(content, video)
    } else if (content.mediaType === 'IMAGE') {
      const image = document.createElement('img')
      image.src = content.content
      image.classList.add(css(Styles.contentImage))

      const elementHolder = document.createElement('div');
      elementHolder.classList.add(css(Styles[this.orientation + 'MediaHolder']));
      elementHolder.appendChild(image)

      this.mediaContainer.appendChild(elementHolder)
      this._displayTimer(content)
    } else if (content.mediaType === 'WEBLINK') {
      const iframe = document.createElement('iframe')
      iframe.src = content.content
      iframe.border = 0

      iframe.width = this.size[this.orientation].width
      iframe.height = this.size[this.orientation].height

      iframe.classList.add(css(Styles.iframeWeblink))

      const iframeHolder = document.createElement('div');
      iframeHolder.classList.add(css(Styles[this.orientation + 'IframeHolder']));
      iframeHolder.appendChild(iframe)

      this.mediaContainer.appendChild(iframeHolder)
      this._displayTimer(content)
    }
  }

  _displayTimer(content,video = null) {
    if(this.timerTimeoutRef) clearTimeout(this.timerTimeoutRef)
    let currentTime = 0;
    this.setState({
      timerElement: `${currentTime}/${Number(content.durationSecs).toFixed(2)}s`
    })
    this.timerInterval = setInterval(() => {
      currentTime += 1;
      this.setState({
        timerElement: `${currentTime}/${Number(content.durationSecs).toFixed(2)}s`
      })
    }, 1000);

    this.timerTimeoutRef = setTimeout(() => {
      clearInterval(this.timerInterval);
      if(this.loop === 0 ) this.setState({timerElement:''}) // Keep duration at end of all ads playing
    }, content.durationSecs * 1000);

    // Call next ad here
    this.timerPlayerTimeout = setTimeout(() => {
      if(video) video.pause()
      this._playNextMedia()
    }, content.durationSecs * 1000)
  }

  _playNextMedia() {
    if (this.mediaContents.length > 0) {
      if(this.loop > 0) return // Ends play after all ads completed playing.
      const nextMedia = this.mediaContents[this.state.currentPlayIndex]
      this._playMedia(nextMedia)
      this.focusToHighlight(this.state.currentPlayIndex)
      if (this.state.currentPlayIndex === (this.mediaContents.length - 1)) {
        this.loop++
      }
      this.setState({
        currentPlayIndex:this.state.currentPlayIndex + 1,
        totalAdsCount:this.mediaContents.length
      })
    }
  }

  focusToHighlight(index) {
    const targetListItem = document.getElementById(`highlightThumbnail-${index}`)
    if (targetListItem) {
      targetListItem.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' })
    }
  }

  isScheduled(timing) {
    if (timing && Object.keys(timing).length > 0) {
      return true
    }
    return false
  }

  isDisplayingAdScheduled() {
    if (
      this.props.ads[this.state.currentPlayIndex - 1] &&
      (
        this.isScheduled(this.props.ads[this.state.currentPlayIndex - 1].campaignTiming ||
          this.props.ads[this.state.currentPlayIndex - 1].timing)
      )
    ) {
      return true
    }
    return false
  }

  render() {
    return (
      <Dialog
        open={this.props.isOpen || false}
        aria-labelledby={this.props.title}
        fullWidth={AppHelper.fullWidthCondition()}
        fullScreen={AppHelper.fullWidthCondition()}
        TransitionComponent={window.innerWidth < 1024 ? Transition : Fade}
        maxWidth='md'
        classes={{
          root: css(Styles.root),
          paper: css(Styles.paper),
        }}
      >
        <div className={css([Styles.modalHeader, AppStyles.modalHeader])}>
          <div className={css(Styles.modalTitle)} title={this.props.title}>
            {this.props.title}
          </div>
          <button className={css(Styles.modalCloseButton)} onClick={this.onCloseModal.bind(this)} disabled={this.state.inProcess}>
            {UiHelper.renderImg({key:'dialogCloseIcon'})}
          </button>
        </div>
        <div className={css(Styles.modalContent)} >
          {this.props.inProcess && !this.props.showError && <div className={css(Styles.loaderBlock)}><CircularProgress /></div>}
          {this.props.showError && !this.props.inProcess && this.props.ads.length === 0 &&
            <div className={css(Styles.noAdsFound)}>{this.props.showError}</div>
          }
          {!this.props.showError && !this.props.inProcess && this.props.ads.length === 0 &&
            <div className={css(Styles.noAdsFound)}>{Helper.getString('noAdsFound')}</div>
          }
          {!this.props.showError && !this.props.inProcess && this.props.ads && this.props.ads.length > 0 &&
            <Fragment key={'mediaContainer'}>
              <div className={css(this._fixThumbnailPosition())}>
                <div className={css(this._fixThumbnailPosition('ThumbnailBlock'))}>
                  <ul className={css([Styles.adsThumbnail, this._fixThumbnailPosition('ListType')])}>
                    {this.props.ads && this.props.ads.map((x, i) => (
                      <li id={'highlightThumbnail-' + i} key={'adThumbnail' + i} className={css(Styles.adsListItems)} onClick={() => { this._playAd(i) }}>
                        <div className={css(Styles.eachThumbnail, (this.state.currentPlayIndex === i + 1) ? Styles.adsListItemsActive : Styles.adsListItemsInactive)}>
                          {this._renderThumbnail(x)}
                          {(this.isScheduled(x.campaignTiming) || this.isScheduled(x.timing)) &&
                            <Tooltip title={Helper.getString('scheduleApplied')} classes={{ popper: css(Styles.tooltip) }}>
                              <span className={css(Styles.scheduleThumbnailIconHolder)}>
                                <i className={'material-icons-outlined ' + css(Styles.scheduleThumbnailIcon)}>update</i>
                              </span>
                            </Tooltip>
                          }
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className={css(Styles.mediaHolder)}>
                  <div key={'mediaContainer'} id='mediaContainer'></div>
                  {this.isDisplayingAdScheduled() &&
                    <Tooltip title={Helper.getString('scheduleApplied')} classes={{ popper: css(Styles.tooltip) }}>
                      <span className={css(Styles.scheduleThumbnailIconHolder)}>
                        <i className={'material-icons-outlined ' + css(Styles.scheduleThumbnailIcon)}>update</i>
                      </span>
                    </Tooltip>}
                </div>
              </div>
              <div key={'mediaInfo'} className={css(Styles.dialogFooterBlock)}>
                <span onClick={() => { this._playPrevAd() }} key={'prevButton'} className={css([Styles.nextPrevBtn, Styles.footerItems, this._disableOnFirstAd()])}>
                  <i className='material-icons-outlined'>chevron_left</i>
                </span>
                <span key={'playbackTime'} id='timer' className={css([Styles.infoSpan, Styles.footerItems])} >{this.state.timerElement}</span>
                <span key={'playbackCount'} className={css([Styles.infoSpan, Styles.footerItems])}>
                  {this.state.currentPlayIndex}/
                  {this.state.totalAdsCount || 0} Ads </span>
                <span onClick={() => { this._playNextAd() }} key={'nextButton'} className={css([Styles.nextPrevBtn, Styles.footerItems, this._disableOnLastAd()])}>
                  <i className='material-icons-outlined'>chevron_right</i></span>
              </div>
            </Fragment>
          }

        </div>
      </Dialog>
    )
  }

  _playAd(i) {
    this.loop = 0
    this._resetTimer()
    this.setState({currentPlayIndex: i},()=>{
      this._playNextMedia()
    })
  }

  _fixThumbnailPosition(text = null) {
    const suffix = text || 'Thumbnail'
    if (this.orientation) {
      return Styles[this.orientation + suffix]
    } else {
      return ''
    }
  }

  _renderThumbnail(current) {
    if (!current) return ''
    if (current.mediaType === 'VIDEO') {
      try {
        const videoThumbnail = AppUiHelper.getVideoThumbnail(current.content)
        return (<img alt={Helper.getString('assetImageAlt')}  className={css(Styles.imageThumbnail)} src={videoThumbnail} />)
      } catch (e) {
        return (<i alt={Helper.getString('assetImageAlt')} className={'material-icons-outlined ' + css(Styles.icons)} >smart_display</i>)
      }
    } else if (current.mediaType === 'WEBLINK') {
      return (<i alt={Helper.getString('assetImageAlt')} className={'material-icons-outlined ' + css(Styles.icons)} >http</i>)
    } else if (current.mediaType === 'IMAGE') {
      return (
        <img alt={Helper.getString('assetImageAlt')}  className={css(Styles.imageThumbnail)} src={current.content} />
      )
    }
  }

  _disableOnFirstAd() {
    return (this.state.currentPlayIndex === 1) ? Styles.disableNextPrevButton : ''
  }

  _disableOnLastAd() {
    return (this.state.currentPlayIndex === this.state.totalAdsCount) ? Styles.disableNextPrevButton : ''
  }

  _resetTimer() {
    if (this.timerPlayerTimeout) clearTimeout(this.timerPlayerTimeout)
    if (this.timerTimeoutRef) clearTimeout(this.timerTimeoutRef)
    if (this.timerInterval) clearTimeout(this.timerInterval)
    this.setState({ timerElement: '' })
  }

  _playNextAd() {
    this.loop = 0
    this._resetTimer()
    this._playNextMedia()
  }

  _playPrevAd() {
    this.loop = 0
    this._resetTimer()
    let prevPlayIndex = this.state.currentPlayIndex - 2
    if (prevPlayIndex < 0) {
      prevPlayIndex = 0
    }
    this.setState({currentPlayIndex: prevPlayIndex},()=>{
      this._playNextMedia()
    })
  }

}

const scaleDownFactor = 6.4
const landscapeScaleDownFactor = 5.33
const Styles = AppConfig.CUSTOM_STYLE ? CustomMessageDialogStyles : StyleSheet.create({
  modalHeader: {
    padding: 20,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 14
  },
  modalTitle: {
    color: '#222222',
    fontSize: 18,
    maxWidth: 230,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  modalContent: {
    // maxWidth: 610,
    // minWidth: 200,
    paddingTop: 16,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 10,
    width: 360,
    minHeight:340,
    // height:480
    '@media (max-width: 1024px)': {
      padding: '10px',
      width: '90vw',
      minHeight: '340px !important',
      margin: '0 auto',
    }
  },
  modalCloseButton: {
    position: 'absolute',
    top: 23,
    right: 30,
    padding: 0,
    border: 'none',
    backgroundColor: 'transparent',
    display: 'flex',
    outline: 'none',
    cursor: 'pointer',
  },
  modalCloseIcon: {
    width: 18,
    height: 18,
    padding: 1,
    fill: 'black',
    borderRadius: AppTheme.borderRadius
  },
  root: {
    zIndex: 13000,
  },
  paper: {
    borderRadius: 40,
    '@media (max-width: 1024px)': {
      maxHeight: 'calc(100% - 140px) !important',
      borderRadius: '20px 20px 0 0',
      bottom: '0 !important',
      position: 'fixed',
      height: 'auto !important'
    }
  },
  contentImage: {
    width: '100%',
    height: '100%',
    objectFit: 'contain'
  },
  contentVideo: {
    width: '100%',
    height: 'auto',
    // maxHeight: 400
  },
  portraitMediaHolder: {
    width: 1080 / scaleDownFactor,
    height: 1920 / scaleDownFactor,
    maxHeight: 1920 / scaleDownFactor,
    overflow: 'hidden',
    border: AppTheme.borderColor + ' solid 1',
    display: 'flex',
    justifyContent: 'center',
    backgroundColor:'#000',
    // transform: 'scale(0.7)'
  },
  landscapeMediaHolder: {
    width: 1920 / landscapeScaleDownFactor,
    height: 1080 / landscapeScaleDownFactor,
    // maxHeight: 1080 / scaleDownFactor,
    overflow: 'hidden',
    border: AppTheme.borderColor + ' solid 1',
    display: 'flex',
    justifyContent: 'center',
    backgroundColor:'#000',
    // transform: 'scale(0.7)'
    '@media (max-width: 1024px)': {
      width: 'auto !important'
    }
  },
  portraitIframeHolder: {
    width: 1080 / scaleDownFactor,
    height: 1920 / scaleDownFactor,
    maxHeight: 1920 / scaleDownFactor,
    overflow: 'hidden',
    border: AppTheme.borderColor + ' solid 1',
    justifyContent: 'center',
    backgroundColor:'#000',
    // transform: 'scale(0.7)'
  },
  landscapeIframeHolder: {
    width: 1920 / landscapeScaleDownFactor ,
    height: 1080 / landscapeScaleDownFactor,
    overflow: 'hidden',
    border: AppTheme.borderColor + ' solid 1',
    justifyContent: 'center',
    backgroundColor:'#000',
    // transform: 'scale(0.7)'
  },
  iframeWeblink: {
    background: AppTheme.backgroundColor,
    border: 'none',
    transform: 'scale(0.19)',
    transformOrigin: 'top left',
  },
  dialogFooterBlock: {
    display: 'flex',
    paddingTop:10,
    paddingBottom:10,
    minHeight: '2em',
    padding: '10 0',
    justifyContent:'space-between'
  },
  infoSpan:{
    minHeight: '2em',
    // padding: '10 0'
  },
  loaderBlock:{
    padding:'8em 0 5em 0em',
    textAlign: 'center',
    minWidth: 360
  },
  noAdsFound:{
    padding:'8em 0 5em 0em',
    textAlign: 'center',
    color: 'tomato',
    minWidth: 360
  },
  nextPrevBtn:{
    color: AppTheme.primaryColor,
    cursor: 'pointer',
  },
  footerItems:{
    display: 'flex',
    alignItems: 'center'
  },
  disableNextPrevButton:{
    pointerEvents: 'none',
    cursor: 'not-allowed',
    color: '#000',
    userSelect: 'none'
  },
  icons:{
    fontSize: 40,
    color: 'lightgray'
  },
  eachThumbnail:{
    width: 50,
    height: 50,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 8,
    position: 'relative'
  },
  imageThumbnail:{
    maxWidth: '100%',
    maxHeight: '100%'
  },
  adsListItems:{
    marginBottom: 10,
    marginRight: 10,
    cursor: 'pointer'
  },
  adsListItemsActive:{
    border: 'solid 1px ' + AppTheme.primaryColor
  },
  adsListItemsInactive:{
    border: 'solid 1px lightgray'
  },
  portraitThumbnail:{
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around'
  },
  landscapeThumbnail:{
    display: 'flex',
    flexDirection: 'column'
  },
  portraitThumbnailBlock:{
    order: 0,
    maxHeight: 1920 / scaleDownFactor,
    overflow:' auto',
    // marginBottom: 10
  },
  landscapeThumbnailBlock:{
    order: 2,
    display: 'flex',
    maxWidth: 1920 / landscapeScaleDownFactor,
    overflow:' auto'
  },
  landscapeListType:{
    order: 2,
    display: 'flex',
    listStyle: 'none',
    margin: 0,
    padding: 0,
    marginTop: 11,
    flexDirection: 'row'
  },
  portraitListType : {
    margin: 0,
    padding: 0,
    minWidth: 68,
    listStyle: 'none'
  },
  scheduleThumbnailIconHolder: {
    position: 'absolute',
    bottom: 2,
    right: 2,
    background: '#ffffff9c',
    borderRadius: 5,
    height: 20,
    fontSize: 10,
    zIndex: 1400
  },
  scheduleThumbnailIcon: {
    color: '#6a6a6a',
    fontSize: 20,
    pointerEvents:'none'
  },
  mediaHolder: {
    position: 'relative'
  },
  tooltip: {
    zIndex: '99999  !important'
  }
})



// WEBPACK FOOTER //
// ./src/components/VenueAdsPlayer.js